type Nullable<T extends object> = {
	[K in keyof T]: T[K] | null | undefined;
};

export function removeNullAttributes<T extends object>(obj: Nullable<T>) {
	const keys = Object.keys(obj) as Array<keyof T>;
	return keys.reduce((result, key) => {
		const value = obj[key];
		if (value === null || value === undefined) return result;
		return { ...result, [key]: value };
	}, {} as T);
}

export function escapeOutput(value: string) {
	return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27').replace(/\//g, '&#x2F');
}

export function formatFileSize(sizeInPx: number | undefined, fractionDigits = 3) {
	if (sizeInPx == null) return undefined;

	const UNITS = ['B', 'kB', 'MB', 'GB', 'TB'];
	let result = sizeInPx;
	let shift = 0;
	while (result >= 1000) {
		result /= 1000;
		shift++;
	}

	const formatter = new Intl.NumberFormat(undefined, { maximumFractionDigits: fractionDigits });
	return `${formatter.format(result)} ${UNITS[shift]}`;
}
